import {
  Box,
  Heading,
  Text,
  Stack,
  Link,
  useToken,
  Separator,
} from "@chakra-ui/react";
import { useEffect } from "react";
import InputC from "../../theme/InputC";
import ButtonC from "../../theme/ButtonC";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
// import { login } from "../../slices/authSlice";
import { useNavigate } from "react-router-dom";
import { toast, Flip } from "react-toastify";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginSchema } from "../../schemas/Login";
import { loadPersistedRoute } from "../../slices/navigation";

export default function LoginPage() {
  const brandPrimary = useToken("colors", "brand.primary");

  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.auth);
  const lastRoute = useSelector((state) => state.navigation.lastVisitedRoute);
  const navigate = useNavigate();

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: zodResolver(LoginSchema) });

  const toastSettings = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    theme: "light",
    transition: Flip,
  };

  useEffect(() => {
    dispatch(loadPersistedRoute());
  }, [dispatch]);

  const onSubmit = async (values) => {
    // const result = await dispatch(login(values));
    // if (login.fulfilled.match(result)) {
    //   toast.success("Logged in", toastSettings);
    //   navigate(lastRoute || "/shop");
    // } else {
    //   const message =
    //     result.payload?.message || error || "Login failed. Please try again.";
    //   toast.error(message, toastSettings);
    // }
  };

  return (
    <Box
      as="main"
      minH="calc(100vh - var(--header-height))"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="bg.canvas"
      px={4}
      mt={{ base: 100, smTo2xl: 120 }}
      mb={50}
    >
      <Box
        w="full"
        maxW="400px"
        p={8}
        borderRadius="md"
        bg="bg.card"
        border="1px solid"
        borderColor="border.subtle"
        boxShadow="sm"
        className="border-tile"
      >
        <Heading
          color="var(--crt-2)"
          size="lg"
          fontSize="2xl"
          mb={2}
          textAlign="center"
        >
          Signin{" "}
     
        </Heading>

        <Text color="text.muted" fontSize="sm" textAlign="center" mb={4}>
          Welcome back to your e-wardrobe.
        </Text>

        <Separator
          orientation="horizontal"
          pb={4}
          color="muted"
          w="80%"
          margin="auto"
        />

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Stack spacing={4}>
            <InputC
              label="Email"
              placeholder="you@example.com"
              isError={!!errors.email}
              errorMsg={errors.email?.message}
              borderColor={errors.email ? "red.500" : "#cfdddfff"}
              {...register("email")}
            />

            <InputC
              label="Password"
              placeholder="Your password"
              type="password"
              isError={!!errors.password}
              errorMsg={errors.password?.message}
              borderColor={errors.password ? "red.500" : "#cfdddfff"}
              {...register("password")}
            />

            <ButtonC
              type="submit"
              isLoading={isSubmitting || status === "loading"}
              isDisabled={isSubmitting || status === "loading"}
              label="Signin"
              mt={4}
              mb={4}
            />

            <Text fontSize="sm" color="var(--crt-3)" textAlign="center">
              Trouble signing in?{" "}
              <Link href="#" color={brandPrimary} fontWeight="semibold">
                Help
              </Link>
            </Text>
          </Stack>
        </form>
      </Box>
    </Box>
  );
}
